import { axiosSingleton } from './generalApi';
import { mapToObject } from '../util/mapToObject';

export const fetchProductsData = id =>
  axiosSingleton
    .get(`/products`, { params: { categorySystemId: id } })
    .then(({ data }) => mapToObject(data))
    .catch(error => {
      throw error;
    });

export const fetchProductsDataList = id =>
  axiosSingleton
    .get(`/products`, { params: { productListId: id } })
    .then(({ data }) => mapToObject(data))
    .catch(error => {
      throw error;
    });

export const fetchCategoryMetaData = url =>
  axiosSingleton
    .get(`/category/categoryByUrl`, { params: { url } })
    .then(({ data }) => mapToObject(data))
    .catch(error => {
      throw error;
    });

export const fetchProductData = id =>
  axiosSingleton
    .get(`/products`, { params: { productUrlPath: id } })
    .then(({ data }) => mapToObject(data))
    .catch(error => {
      throw error;
    });



// WEBPACK FOOTER //
// ./src/api/productData.js